/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FontSize } from './vendor/_rfs.mixin';
import { Hover, HoverFocus } from './mixins/_hover.mixin';


export default $ => css`
  .close {
    float: right;
    ${new FontSize($.closeFontSize).include($)};
    font-weight: ${$.closeFontWeight};
    line-height: 1;
    color: ${$.closeColor};
    text-shadow: ${$.closeTextShadow};
    opacity: 0.5;

    ${new Hover().include($, css`
      color: ${$.closeColor};
      text-decoration: none;
    `)}

    &:not(:disabled):not(.disabled) {
      ${new HoverFocus().include($, css`
        opacity: 0.75;
      `)}
    }
  }

  button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
  }

  a.close.disabled {
    pointer-events: none;
  }
`;
